import ProductPriceManagementColumnModel from './product-price-management-column-model'
import React, { useState } from 'react'
import CommonTablePage from '../../../../components/common/common-table/common-table-page'
import { urlKey } from '../../../../services/api/api-urls'
import { ApiRequest } from '../../../../services/api/api'
import SweetAlertService from '../../../../services/lib/utils/sweet-alert-service'
import { getUserId } from '../../../../services/lib/utils/auth.utils'

const ProductPriceManagementPage = (props: {baseProductId: any, isEmbedded?: boolean}): any => {
  const [data, setData] = useState<any>()
  
  // 转换数字字段的函数
  const transformNumericFields = (data: any) => {
    const numericFields = ['price', 'originalPrice', 'quantiy'];
    const processedData = { ...data };
    
    numericFields.forEach(field => {
      if (processedData[field] !== undefined && processedData[field] !== null) {
        // 确保转换为数字，如果是空字符串则转为 0
        processedData[field] = processedData[field] === '' ? 0 : Number(processedData[field]);
      }
    });
    
    return processedData;
  };

  return (
    <CommonTablePage
      urlInfoKey={urlKey.ProductPrice}
      getAllUrl={'ProductPrice/GetProductPriceByProduct?baseProductId=' + props.baseProductId}
      title={props.isEmbedded ? '' : 'Product Price Management'}
      mappingUpdateData={(dataDetail: any) => {
        const transformedData = transformNumericFields(dataDetail);
        return {...transformedData, baseProductId: props.baseProductId};
      }}
      mappingRenderData={(data: any) => {
        setData(data.map((row: any) => ({...row, groupName: row.group1?.group1Name})).filter((item: any) => item.group1 === null)[0])
        return data.map((row: any) => ({...row, groupName: row.group1?.group1Name}))
      }}
      // Hide QTY/Carton column in the Edit Base Product dialog (Price tab)
      column={ ProductPriceManagementColumnModel.Column}
      actionButtons={[
        {
          icon: 'danger', //Button attr of Ant design (danger, ghost)
          tooltip: 'Generate Quotation For All Customer',
          isFreeAction: true,
          onClick: async (event: any, rowData: any) => {

            if (!data || !data.productPriceId){
              // console.log(data.productPriceId)              
              await SweetAlertService.errorMessage("Please set the price for all customer group!")
              return
            }
          
            // call generate quotation api here
            const result =await SweetAlertService.confirmMessage("Are you sure, this will generate draft quotations of this product for all customers? ")
            if (result){
              ApiRequest({url: 'ProductPrice/GenerateQuotaByProductPrice?id=' + data.productPriceId+"&userId="+getUserId(), method: 'put'})
              .then((res: any) => {
                console.log(res)
              })
            }
          }
        },
      ]}
    />
  )
}

export default ProductPriceManagementPage
